import axios from 'axios';
import jsonToFormData from 'json-form-data';
import { TManuscriptDataState } from './types';

export const postManuscriptRequest = async (data: TManuscriptDataState) => {
  const formData = jsonToFormData(data);
  return await axios.post(`/api/manuscript/`, formData);
};
